import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { fetchAdvertiserList, getAdvertiserPartnerInfo } from '@/api/advertiser/manage.ts';
import { grantRechargeCreate } from '@/api/grant/grant';
import { currencyOptions, taxForAdvOptions } from '@/common/permission';

var defaultQuery = {
  adv: '',
  adv_id: '',
  currency: 1,
  money: undefined, // 金额
  remark: '' // 备注
};

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: _extends({}, defaultQuery),
      // 3s信息
      advInfo: {
        username_3s: '',
        country_code: ''
      },
      // 广告主数据
      advertiserList: [],
      currencyOptions: currencyOptions,
      taxForAdvOptions: taxForAdvOptions
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    dialogAttrs: function dialogAttrs() {
      return _extends({
        title: '新增充值'
      }, this.$attrs);
    },
    rules: function rules() {
      return {
        adv: { required: true, trigger: 'change', message: '请选择广告主' },
        money: { required: true, trigger: 'blur', message: '请输入金额' }
      };
    },
    currencyList: function currencyList() {
      return _.map({ 1: currencyOptions['1'] }, function (v, k) {
        return {
          label: v,
          value: Number(k)
        };
      });
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      var _this = this;

      this.formValue = _extends({}, defaultQuery);
      this.$nextTick(function () {
        _this.$refs.form.clearValidate();
      });
    }
  },
  mounted: function mounted() {},

  methods: {
    getAdvertiserList: function getAdvertiserList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchAdvertiserList(params);

              case 2:
                res = _context.sent;

                _this2.advertiserList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    changeAdvertiser: function changeAdvertiser(option) {
      this.formValue.adv_id = option.id;
      this.advInfo.username_3s = option.name + '_3s';
      // 获取国家信息
      this.getAdvertiserCountryCode(option.id, option.country);
    },
    getAdvertiserCountryCode: function getAdvertiserCountryCode(id, country) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, partnerInfoList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getAdvertiserPartnerInfo({ adv_id: id });

              case 3:
                res = _context2.sent;
                partnerInfoList = res.data.data.list || [];
                // 查不到合同信息 国家信息保持现状

                _this3.advInfo.country_code = partnerInfoList.length ? partnerInfoList[0].country_code : country;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                _this3.advInfo.country_code = country;
                console.log(_context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8]]);
      }))();
    },
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    submit: function submit() {
      var _this4 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          grantRechargeCreate(_.omit(_this4.formValue, ['adv'])).then(function () {
            _this4.closeDialog();
            _this4.$emit('save-success');
          }).finally(function () {
            _this4.loading = false;
          });
        }
      });
    }
  }
};